import firebase from 'firebase/app';
import 'firebase/database';

const config = {
    apiKey: "AIzaSyA3X_nNMIu4ByN0vax9Wyod-7yylxbzrbI",
    authDomain: "foodna-driver-android.firebaseapp.com",
    databaseURL: "https://foodna-driver-android.firebaseio.com",
    projectId: "foodna-driver-android",
    storageBucket: "foodna-driver-android.appspot.com",
    messagingSenderId: "381121480493"
};

const app = firebase.initializeApp(config);
export default app;



// WEBPACK FOOTER //
// ./src/http/firebase.js